import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

// Application Insights
import { environment } from '../environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { CustomErrorHandler } from './services/custom-error-handler.service';
import { GIPConfirmComponent } from './components/shared/shared.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule, GIPConfirmComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(private router: Router) {
    var angularPlugin = new AngularPlugin();
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment['instrumentationKey'],
        disableExceptionTracking: true,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new CustomErrorHandler()]
          }
        }
      }
    });
    appInsights.loadAppInsights();
  }
}
